import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icons/cart.svg'


const _withScopeId = n => (_pushScopeId("data-v-8988bd44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "cart"
    })
  ])
], -1))
const _hoisted_2 = { class: "mini-cart" }
const _hoisted_3 = {
  key: 0,
  class: "mini-cart__cart"
}
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "item-head" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "logo" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "description" }
const _hoisted_10 = { class: "services" }
const _hoisted_11 = {
  key: 0,
  class: "service"
}
const _hoisted_12 = { class: "total" }
const _hoisted_13 = { class: "cost" }
const _hoisted_14 = { class: "cpv" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "bottom" }
const _hoisted_20 = {
  key: 1,
  class: "empty"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "cart"
  })
], -1))
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "cart-clean-popup__header" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_text = _resolveComponent("app-text")!
  const _component_app_badge = _resolveComponent("app-badge")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_router = _resolveComponent("app-router")!
  const _component_app_modal = _resolveComponent("app-modal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.STREAMERS.length === 0 ? 'empty' : '', "cart"]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMiniCart && _ctx.toggleMiniCart(...args)))
    }, [
      (_ctx.STREAMERS.length > 0 && _ctx.$isWindow.desktop)
        ? (_openBlock(), _createBlock(_component_app_text, {
            key: 0,
            text: _ctx.getCartText
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _hoisted_1
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.getStreamers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStreamers, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.streamer_id,
                  class: "item"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: item.avatar_url,
                          alt: "logo"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_app_text, {
                          text: item.display_name,
                          tag: "p",
                          "font-size": "12",
                          status: "white"
                        }, null, 8, ["text"]),
                        _createVNode(_component_app_text, {
                          text: _ctx.getAdvertisingCampaignDateRange(item),
                          tag: "p",
                          "font-size": "12",
                          status: "white",
                          style: {"margin-right":"10px"}
                        }, null, 8, ["text"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_app_badge, {
                        text: _ctx.getServices(item),
                        type: "solid",
                        color: "black",
                        size: "mini"
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.services, (service) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: service.service_id
                      }, [
                        (service.quantity > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_app_text, {
                                text: _ctx.getText(service.service_id),
                                tag: "p",
                                status: "white"
                              }, null, 8, ["text"]),
                              _createVNode(_component_app_text, {
                                text: service.quantity,
                                tag: "p",
                                status: "white",
                                class: "quantity"
                              }, null, 8, ["text"]),
                              _createVNode(_component_app_text, {
                                text: _ctx.getPrice(service),
                                tag: "p",
                                status: "white"
                              }, null, 8, ["text"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_app_badge, {
                text: _ctx.getTotalServices,
                type: "solid",
                color: "black",
                size: "mini"
              }, null, 8, ["text"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_app_text, {
                  text: "Итого:",
                  "font-size": "14",
                  status: "gray"
                }),
                _createVNode(_component_app_text, {
                  text: _ctx.getTotalCost,
                  "font-size": "18",
                  status: "white",
                  "line-height": "22"
                }, null, 8, ["text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_app_text, {
                text: "Средний CPV",
                status: "success",
                tag: "p"
              }),
              _createVNode(_component_app_text, {
                text: _ctx.getCPV,
                status: "white",
                tag: "p",
                "font-size": "16"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_app_text, {
                  text: "Прогнозируемое количество просмотров:",
                  status: "gray",
                  tag: "p"
                }),
                _createVNode(_component_app_badge, {
                  text: _ctx.getViews,
                  type: "solid",
                  size: "mini",
                  color: "blue-dark"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_app_text, {
                  text: "Прогнозируемое время рекламного эфира:",
                  status: "gray",
                  tag: "p"
                }),
                _createVNode(_component_app_badge, {
                  text: `~ ${_ctx.CART_TOTAL.airtime} минуты`,
                  type: "solid",
                  color: "purple",
                  size: "mini"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_app_text, {
                  text: "Прогнозируемое количество уникальных зрителей:",
                  status: "gray",
                  tag: "p"
                }),
                _createVNode(_component_app_badge, {
                  text: _ctx.getUniqueViewers,
                  type: "solid",
                  size: "mini",
                  color: "blue-dark"
                }, null, 8, ["text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_app_button, {
                text: "Очистить корзину",
                type: "white",
                "icon-name": "icon-cross",
                "icon-position": "right",
                "icon-size": "10",
                size: "small",
                onClick: _ctx.openCartCleanPopup
              }, null, 8, ["onClick"]),
              _createVNode(_component_app_router, {
                href: "/cart",
                target: "_self"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_button, {
                    text: "Перейти в корзину",
                    type: "success",
                    size: "small",
                    "icon-position": "right",
                    "icon-name": "icon-arrow-right",
                    "icon-size": "10"
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_app_text, {
                text: "В корзине пусто :(",
                tag: "p",
                "font-size": "18",
                "line-height": "20",
                class: "title",
                status: "white"
              }),
              _createVNode(_component_app_text, {
                text: "Перейдите на витрину и добавьте стримера",
                status: "gray",
                class: "info",
                tag: "p"
              })
            ]),
            _createVNode(_component_app_button, {
              text: "Перейти к витрине",
              "icon-name": "icon-arrow-right",
              "icon-size": "9",
              "icon-position": "right",
              onClick: _ctx.goToShowcase
            }, null, 8, ["onClick"])
          ]))
    ])), [
      [_vShow, _ctx.isShowMiniCart],
      [_directive_click_outside, _ctx.clickOutside]
    ]),
    _createVNode(_component_app_modal, {
      "is-show": _ctx.isCartCleanPopup,
      class: "cart-clean-popup",
      onClose: _ctx.closeCartCleanPopup
    }, {
      heading: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_app_text, {
            "font-size": "16",
            text: "Вы уверены, что хотите очистить корзину?"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_app_button, {
              text: "Очистить корзину",
              type: "white",
              onClick: _ctx.emptyCart
            }, null, 8, ["onClick"]),
            _createVNode(_component_app_button, {
              text: "Отмена",
              onClick: _ctx.closeCartCleanPopup
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-show", "onClose"])
  ], 64))
}